exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".warranty-link .button-text{-webkit-user-select:text;-ms-user-select:text;user-select:text}.cf .warranty-link .button-text,.hitachi .warranty-link .button-text{text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/claim/shared/components/warranty-link.scss
// module id = 5069
// module chunks = 0